module.exports = __webpack_public_path__ + "Tinebase/js/ace-ext-language_tools-FAT.js";